(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compact-messages"] && !Shopify.designMode) return;
  try {
    

(function() {
  var messages = document.getElementById('mobile_message');
  var counter = 1;

  if (counter <= messages.length) {
    setInterval(function() {
      messages[0] = messages[counter];
      console.log(messages[counter]);
      counter++;

      if (counter === messages.length){
        counter = 1;
      }
    }, 4000);
  }
})();

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-messages"]) return;
  try {
    

(function() {
  var messages = document.getElementById('mobile_message');
  var counter = 1;

  if (counter <= messages.length) {
    setInterval(function() {
      messages[0] = messages[counter];
      console.log(messages[counter]);
      counter++;

      if (counter === messages.length){
        counter = 1;
      }
    }, 4000);
  }
})();

  

  } catch(e) { console.error(e); }
})();
})();
